<template>
  <navbar />
  <section class="section">
    <div class="container">
      <h1 class="title">
        Copy Starter Template
      </h1>

      <p class="subtitle">
        Copy our
        <a
          :href="
            `https://docs.google.com/spreadsheets/d/${starterTemplateSpreadsheetId}/edit`
          "
          target="_blank"
          rel="noopener noreferrer"
          >Balance Sheet Starter Template</a
        >
        into your Google Drive.
      </p>

      <Form
        ref="form"
        v-slot="{ errors, isSubmitting }"
        :initial-values="initialValues"
        :validation-schema="validationSchema"
        @submit="submit"
      >
        <div class="field">
          <label class="label">Save As</label>
          <div class="control">
            <Field
              :class="{ 'is-danger': errors.name }"
              :disabled="isSubmitting"
              as="input"
              class="input"
              name="name"
              placeholder="Enter Spreadsheet Name"
            />
            <p v-if="errors.name" class="help is-danger">{{ errors.name }}</p>
          </div>
        </div>

        <div class="field is-grouped">
          <div class="control">
            <button
              :class="{ 'is-loading': isSubmitting }"
              :disabled="isSubmitting"
              class="button is-link"
            >
              Save
            </button>
          </div>
          <div class="control">
            <button v-if="isSubmitting" class="button is-light" disabled>
              Cancel
            </button>
            <router-link v-else class="button is-light" to="/spreadsheets">
              Cancel
            </router-link>
          </div>
        </div>
      </Form>
    </div>
  </section>
</template>

<script>
import { object, string } from 'yup';
import { Field, Form } from 'vee-validate';
import Navbar from './Navbar.vue';

export default {
  components: {
    Field,
    Form,
    Navbar,
  },

  setup() {
    return {
      initialValues: {
        name: `My Balance Sheet ${new Date().getFullYear()}`,
      },
      validationSchema: object().shape({
        name: string().required(),
      }),
    };
  },

  computed: {
    starterTemplateSpreadsheetId() {
      return process.env.VUE_APP_STARTER_TEMPLATE_SPREADSHEET_ID;
    },
  },

  methods: {
    async submit(values) {
      try {
        const res = await window.gapi.client.drive.files.copy({
          fileId: this.starterTemplateSpreadsheetId,
          resource: {
            name: values.name,
          },
        });

        this.$router.push(`/spreadsheets/${res.result.id}`);
      } catch (error) {
        this.$refs.form.setFieldError('name', error.result.error.message);
      }
    },
  },
};
</script>
